const actionType = {
    GET_CONSOLIDATEDREPORT_CHAPTER:'GET_CONSOLIDATEDREPORT_CHAPTER',
    GET_CONSOLIDATEDREPORT_CHAPTER_SUCCESS:'GET_CONSOLIDATEDREPORT_CHAPTER_SUCCESS',
    GET_CONSOLIDATEDREPORT_CHAPTER_FAILURE:'GET_CONSOLIDATEDREPORT_CHAPTER_FAILURE'
}
export default actionType 